import * as React from "react";

import { DatasheetFieldComponentGetDto } from "@common/dto/datasheet/field-component/get-dto";
import { IDatasheetResultElement } from "@modules/datasheets/components/result/types/datasheet-element";
import { getCommonFieldBasedElementParams, useDatasheetElementController } from "@modules/datasheets/components/result/controllers/datasheet-element";
import { DatasheetCheckboxFieldValue } from "@common/dto/datasheet/field-component/checkbox-field";

export type CheckboxFieldProps = IDatasheetResultElement<DatasheetFieldComponentGetDto>;

export const useCheckboxFieldController = (props: CheckboxFieldProps) => {
  const { datasheetElement, onChange } = props;

  const getCheckedState = () => {
    const currentValue = (datasheetElement.original.field as any).value;
    return currentValue === DatasheetCheckboxFieldValue.checked;
  };

  const [checked, setChecked] = React.useState(getCheckedState);

  React.useEffect(() => {
    const newChecked = getCheckedState();
    setChecked(prev => prev !== newChecked ? newChecked : prev);
  }, [datasheetElement.original.field]);

  const { 
    headingSizeDependencies, 
    headingPlacedHorizontally, 
    headingPosition 
  } = getCommonFieldBasedElementParams(props);

  const baseDatasheetElementController = useDatasheetElementController(
    props,
    { headingSizeDependencies }
  );

  const handleCheckboxFieldValueChange = React.useCallback((newChecked: boolean) => {
    setChecked(newChecked);
    onChange(datasheetElement.id, {
      ...datasheetElement,
      original: {
        ...datasheetElement.original,
        field: {
          ...datasheetElement.original.field,
          value: newChecked ? DatasheetCheckboxFieldValue.checked : DatasheetCheckboxFieldValue.unchecked,
        },
      },
    });
  }, [datasheetElement, onChange]);

  return {
    handleCheckboxFieldValueChange,
    checked,
    headingPosition,
    headingPlacedHorizontally,
    ...baseDatasheetElementController,
  };
};
